import { stroot } from '@birdi/js-sdk'
import React from 'react';
import AsyncSelect from 'react-select/async';
import { css } from '@emotion/react';
import { forms } from '@birdi/theme'
import { mapFolders } from '@birdi/js-sdk';

export function loadFolderOptions() {
  return mapFolders.getFolders(stroot('k1665s'))
    .then((response) => {
      if (response.status === 200 && response.body) {
        return response.body.map((folder) => ({
          value: folder.id,
          label: folder.name,
        }));
      }
      return [];
    })
    .catch((error) => {
      console.error('Failed to fetch folders:', error);
      return [];
    });
}

export default ({
  onChange,
  defaultValue,
  placement = 'bottom',
  placeholder = "All folders",
  disabledOptions = [],
  controlStyles = {},
  isClearable = true,
  isDisabled = false,
}: {
  onChange: (option: any) => void;
  defaultValue: string | null;
  placement?: string;
  placeholder?: string;
  disabledOptions?: string[];
  controlStyles?: any;
  isClearable?: boolean;
  isDisabled?: boolean;
}) => {
  const Option = (props: any) => (
    <button
      type="button"
      onClick={() => props.selectOption(props.data)}
      disabled={disabledOptions.includes(props.data.value)}
      css={(theme) => css`
        text-align: left;
        padding: 0.5em;
        margin: 0;
        width: 100%;
        &:disabled {
          background: ${theme.mono20};
        }
      `}
    >
      {props.data.label}
    </button>
  );

  // If defaultValue is provided, we need to find the folder name
  const [defaultOption, setDefaultOption] = React.useState<any>(null);
  const [isLoadingDefault, setIsLoadingDefault] = React.useState(false);

  React.useEffect(() => {
    if (defaultValue) {
      setIsLoadingDefault(true);
      loadFolderOptions().then((options) => {
        const folder = options.find((option) => option.value === defaultValue);
        if (folder) {
          setDefaultOption(folder);
        }
        setIsLoadingDefault(false);
      });
    } else {
      setDefaultOption(null);
      setIsLoadingDefault(false);
    }
  }, [defaultValue]);

  return (
    <AsyncSelect
      menuPlacement={placement as any}
      defaultOptions
      cacheOptions
      components={{ Option }}
      value={defaultOption}
      onChange={(option) => onChange(option)}
      loadOptions={() => loadFolderOptions()}
      placeholder={isLoadingDefault ? "Loading..." : placeholder}
      isClearable={isClearable}
      isLoading={isLoadingDefault}
      isDisabled={isDisabled}
      menuPortalTarget={document.body}
      styles={{
        ...forms.reactSelect,
        menuPortal: (base) => ({
          ...base,
          zIndex: 10000,
          pointerEvents: 'visible',
        }),
        container: (base) => ({
          ...base,
          width: '100%',
        }),
        input: (base) => ({
          ...base,
          padding: '0.65rem',
        }),
        control: (base) => ({
          ...base,
          height: '100%',
          borderRadius: '3px',
          border: `solid #ddd 1px`,
          width: '100%',
          ...controlStyles,
        }),
        menu: (base) => ({
          ...base,
          maxHeight: '200px',
          zIndex: 9999,
          position: 'absolute',
          overflow: 'hidden',
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: '200px',
          overflowY: 'auto',
          overflowX: 'hidden',
          '&::-webkit-scrollbar': {
            width: '12px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '3px',
          },
        }),
      }}
    />
  );
}
